import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import compose from "recompose/compose";
import classNames from "classnames";

const styles = {
  button: {
    background: "#1ab394 !important",
    borderRadius: 3,
    border: 0,
    color: "#ffffff"
  }
};

function SubmitButton(props) {
  return (
    <Button
      type="submit"
      disabled={props.disabled}
      className={classNames({
        buttonSubmitDisabled: props.semSpinner,
        [props.classes.button]: true,
        submit: true
      })}
    >
      {props.children && !props.disabled ? (
        props.children
      ) : props.semSpinner ? (
          props.children
        )
        :(
        <i className="fa fa-spinner fa-pulse" />
      )}
    </Button>
  );
}

SubmitButton.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  loading: state.loading.loading
});

export default compose(
  withStyles(styles, {
    name: "SubmitButton"
  }),
  connect(mapStateToProps)
)(SubmitButton);



// WEBPACK FOOTER //
// ./src/components/Forms/SubmitButton/index.js